import {
    CreateDraftQuestRequest,
    RequestApproveRequest,
    RequestModificationsRequest,
    UpdateQuestRequest
} from 'src/types/quests';
import { _callAuthenticatedAPI } from '../apiCaller';
import { HTTPMethod } from 'src/enums/request';

export function postRequestModifications(
    questId: string,
    params: RequestModificationsRequest
): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/request-modifications`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.POST, params);
}

export function updateQuest(
    questId: string,
    params: UpdateQuestRequest
): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/update-quest`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.PUT, params);
}

export function postRequestApprove(
    questId: string,
    params: RequestApproveRequest
): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/approve`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.POST, params);
}

export function getQuest(questId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}

export function postAutoMergeQuest(questId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/auto-merge`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.POST);
}

export function getAsyncJob(jobId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/job/${jobId}`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}

export function getQuestSolution(questId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/solution`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}

export function getQuestActivities(questId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/activities`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}

export function getQuestLlmInfo(questId: string): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/llm-info`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
}

export function postCreateDraftQuest(
    params: CreateDraftQuestRequest
): Promise<{ status: string; data: { questId: string; title: string } }> {
    return _callAuthenticatedAPI('backend/api/v1/quest', 'POST', params);
}

export function deleteDraftQuest(questId: string): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/${questId}`,
        HTTPMethod.DELETE
    );
}

export function postBeehiveHumanReview(questId: string): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/${questId}/human-review`,
        HTTPMethod.POST
    );
}

export function postQuestHumanReview(
    questId: string,
    params: RequestModificationsRequest
): Promise<any> {
    let endpointUrl = `backend/api/v1/quest/${questId}/human-review`;
    return _callAuthenticatedAPI(endpointUrl, HTTPMethod.POST, params);
}
